import React, {Component} from 'react';
import Select from"../../../local_node_modules/react-select"
import '../../../local_node_modules/react-select/dist/react-select.css';
import Datetime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';
import moment from 'moment';
import 'moment/locale/tr';
import {UncontrolledTooltip} from 'reactstrap';
import {validateField} from "../../../common/validation";
import {deepCopyObject} from "../../../helper/helper";
import {isValidTouristInfo} from "../../../common/componentValidation";
import DefaultModal from "../DefaultModal";

class TouristInfoModal extends Component {

	constructor(props) {
		super(props);
		this.state = {error: {}, touristInfo: null};
		this.isOpen = this.isOpen.bind(this);
		this.validateField = this.validateField.bind(this);
		this.onChange = this.onChange.bind(this);
		this.setTouristInfo = this.setTouristInfo.bind(this);
		this.checkValue = this.checkValue.bind(this);
	}

	componentWillMount() {
		this.setState({
			touristInfo: this.props.touristInfo,
			modal: this.props.modal,
			title: this.props.title
		});
	}

	validateField(e) {
		let id = e.target.id;
		let rule = e.target.dataset.vdata;
		let boundary = e.target.dataset.vlength;
		let result = validateField(rule, boundary, e.target.value);
		let error = this.state.error;
		error = Object.assign(error, {[id]: result});
		this.setState({error});
	}

	validateClass(id) {
		let error = this.state.error;
		return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
	}

	validateMessage(id) {
		let error = this.state.error;
		return (error[id] === undefined ? '' : (error[id].message));
	}

	setTouristInfo(e) {
		e.preventDefault();
		let touristInfo = deepCopyObject(this.state.touristInfo);
		let result = isValidTouristInfo(touristInfo);
		let error = result.error;
		let valid = result.valid;
		if (valid) {
			this.props.listener(touristInfo);
		} else {
			this.setState({error});
		}
	}

	onChange(e) {
		let touristInfo = deepCopyObject((this.state.touristInfo ? this.state.touristInfo : {}));
		touristInfo[e.target.name] = e.target.value;
		this.setState({touristInfo});
	}

	isOpen() {
		this.props.listener(this.props.touristInfo);
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.touristInfo !== nextProps.touristInfo) {
			this.setState({touristInfo: nextProps.touristInfo});
		}
	}

	checkValue(key){
		return ((this.state.touristInfo && this.state.touristInfo[key]) ? this.state.touristInfo[key] :  "");
	}

	render() {
		return (
			<DefaultModal
				isOpen={this.props.modal}
				title={this.props.title}
				size={"lg"}
				confirmBtnText="Kaydet"
				cancelBtnText="İptal"
				onConfirm={(e) => this.setTouristInfo(e)}
				onCancel={this.isOpen}>
				<div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 row">
					<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row">
						<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
							<label>Adı*</label>
						</div>
						<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
							<div className={"form-group" + this.validateClass("firstName")}>
								<input className="form-control"
									   type="text"
									   data-vlength="1,255"
									   id="firstName"
									   name="firstName"
									   onBlur={(e) => this.validateField(e)}
									   onChange={this.onChange}
									   value={this.checkValue("firstName")}/>
								{this.validateMessage("firstName") !== "" &&
								<UncontrolledTooltip placement="right" target={"firstName"} delay={0}>
									{this.validateMessage("firstName")}
								</UncontrolledTooltip>}
							</div>
						</div>
					</div>
					<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row">
						<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
							<label>Soyadı*</label>
						</div>
						<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
							<div className={"form-group" + this.validateClass("familyName")}>
								<input className="form-control"
									   type="text"
									   data-vlength="1,255"
									   id="familyName"
									   name="familyName"
									   onBlur={(e) => this.validateField(e)}
									   onChange={this.onChange}
									   value={this.checkValue("familyName")}/>
								{this.validateMessage("familyName") !== "" &&
								<UncontrolledTooltip placement="right" target={"familyName"} delay={0}>
									{this.validateMessage("familyName")}
								</UncontrolledTooltip>}
							</div>
						</div>
					</div>
					<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row">
						<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
							<label>Ülke*</label>
						</div>
						<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
							<div className={"form-group" + this.validateClass("touristCountry")}>
								<Select
									id="touristCountry"
									value={this.checkValue("touristCountry")}
									clearable={false}
									noResultsText="Sonuç yok"
									clearValueText="Temizle"
									placeholder="Seçiniz..."
									onChange={(e) => e && this.onChange({target: {name: "touristCountry", value: e.value}})}
									options={this.props.countries.map(country => ({value: country.longNameEn, label: country.longNameEn}))}
								/>
								{this.validateMessage("touristCountry") !== "" &&
								<UncontrolledTooltip placement="right" target={"touristCountry"} delay={0}>
									{this.validateMessage("touristCountry")}
								</UncontrolledTooltip>}
							</div>
						</div>
					</div>
					<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row">
						<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
							<label>Uyruk*</label>
						</div>
						<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
							<div className={"form-group" + this.validateClass("touristNationality")}>
								<Select
									id="touristNationality"
									value={this.checkValue("touristNationality")}
									clearable={false}
									noResultsText="Sonuç yok"
									clearValueText="Temizle"
									placeholder="Seçiniz..."
									onChange={(e) => e && this.onChange({target: {name: "touristNationality", value: e.value}})}
									options={this.props.countries.map(country => ({value: country.shortName, label: country.longNameEn}))}
								/>
								{this.validateMessage('touristNationality') !== "" &&
								<UncontrolledTooltip placement="right" target="touristNationality" delay={0}>
									{this.validateMessage("touristNationality")}
								</UncontrolledTooltip>}
							</div>
						</div>
					</div>
					<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row">
						<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
							<label>İl*</label>
						</div>
						<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
							<div className={"form-group" + this.validateClass("touristCity")}>
								<input className="form-control"
									   type="text"
									   data-vlength="1,255"
									   id="touristCity"
									   name="touristCity"
									   onBlur={(e) => this.validateField(e)}
									   onChange={this.onChange}
									   value={this.checkValue("touristCity")}/>
								{this.validateMessage("touristCity") !== "" &&
								<UncontrolledTooltip placement="right" target={"touristCity"} delay={0}>
									{this.validateMessage("touristCity")}
								</UncontrolledTooltip>}
							</div>
						</div>
					</div>
					<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row">
						<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
							<label>İlçe*</label>
						</div>
						<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
							<div className={"form-group" + this.validateClass("touristCitySubdivision")}>
								<input className="form-control"
									   type="text"
									   data-vlength="1,255"
									   id="touristCitySubdivision"
									   name="touristCitySubdivision"
									   onBlur={(e) => this.validateField(e)}
									   onChange={this.onChange}
									   value={this.checkValue("touristCitySubdivision")}/>
								{this.validateMessage("touristCitySubdivision") !== "" &&
								<UncontrolledTooltip placement="right" target={"touristCitySubdivision"} delay={0}>
									{this.validateMessage("touristCitySubdivision")}
								</UncontrolledTooltip>}
							</div>
						</div>
					</div>
					<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row">
						<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
							<label>Pasaport No*</label>
						</div>
						<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
							<div className={"form-group" + this.validateClass("touristPassportNo")}>
								<input className="form-control"
									   type="text"
									   data-vlength="1,255"
									   id="touristPassportNo"
									   name="touristPassportNo"
									   onBlur={(e) => this.validateField(e)}
									   onChange={this.onChange}
									   value={this.checkValue("touristPassportNo")}/>
								{this.validateMessage("touristPassportNo") !== "" &&
								<UncontrolledTooltip placement="right" target={"touristPassportNo"} delay={0}>
									{this.validateMessage("touristPassportNo")}
								</UncontrolledTooltip>}
							</div>
						</div>
					</div>
					<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row">
						<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
							<label>Pasaport Tarihi*</label>
						</div>
						<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
							<div className={"form-group" + this.validateClass("touristPassportDate")}>
								<Datetime locale="tr"
										  className="datepicker"
										  input={true}
										  inputProps={{id: "touristPassportDate"}}
										  onBlur={(momentObj) => this.validateField({
											  target: {
												  name: "touristPassportDate",
												  dataset: {'vdata': "date", 'vlength': "1,255"},
												  value: (!(typeof momentObj === "string") ? momentObj.format("DD-MM-YYYY") : momentObj)
											  }
										  })}
										  closeOnSelect={true}
										  value={moment(this.checkValue("touristPassportDate"), "YYYY-MM-DD", true).isValid() ? moment(this.checkValue("touristPassportDate")).format("DD-MM-YYYY") : this.checkValue("touristPassportDate")}
										  dateFormat="DD-MM-YYYY"
										  timeFormat={false}
										  isValidDate={function (current) {
											  return current.isBefore(Datetime.moment());
										  }}
										  onChange={(momentObj) => this.onChange({
											  target: {
												  name: 'touristPassportDate',
												  value: (!(typeof momentObj === "string") ? momentObj.format("YYYY-MM-DD") : momentObj)
											  }
										  })}/>
								{this.validateMessage("touristPassportDate") !== "" &&
								<UncontrolledTooltip placement="right" target={"touristPassportDate"} delay={0}>
									{this.validateMessage("touristPassportDate")}
								</UncontrolledTooltip>}
							</div>
						</div>
					</div>
					<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row">
						<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
							<label>Banka Hesap No</label>
						</div>
						<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
							<div className={"form-group" + this.validateClass("bankAccountNo")}>
								<input className="form-control"
									   type="text"
									   data-vlength="0,255"
									   id="bankAccountNo"
									   name="bankAccountNo"
									   onBlur={(e) => this.validateField(e)}
									   onChange={this.onChange}
									   value={this.checkValue("bankAccountNo")}/>
								{this.validateMessage("bankAccountNo") !== "" &&
								<UncontrolledTooltip placement="right" target={"bankAccountNo"} delay={0}>
									{this.validateMessage("bankAccountNo")}
								</UncontrolledTooltip>}
							</div>
						</div>
					</div>
					<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row">
						<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
							<label>Banka Adı</label>
						</div>
						<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
							<div className={"form-group" + this.validateClass("bankName")}>
								<input className="form-control"
									   type="text"
									   data-vlength="0,255"
									   id="bankName"
									   name="bankName"
									   onBlur={(e) => this.validateField(e)}
									   onChange={this.onChange}
									   value={this.checkValue("bankName")}/>
								{this.validateMessage("bankName") !== "" &&
								<UncontrolledTooltip placement="right" target={"bankName"} delay={0}>
									{this.validateMessage("bankName")}
								</UncontrolledTooltip>}
							</div>
						</div>
					</div>
					<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row">
						<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
							<label>Banka Şube Adı</label>
						</div>
						<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
							<div className={"form-group" + this.validateClass("bankBranchName")}>
								<input className="form-control"
									   type="text"
									   data-vlength="0,255"
									   id="bankBranchName"
									   name="bankBranchName"
									   onBlur={(e) => this.validateField(e)}
									   onChange={this.onChange}
									   value={this.checkValue("bankBranchName")}/>
								{this.validateMessage("bankBranchName") !== "" &&
								<UncontrolledTooltip placement="right" target={"bankBranchName"} delay={0}>
									{this.validateMessage("bankBranchName")}
								</UncontrolledTooltip>}
							</div>
						</div>
					</div>
					<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row">
						<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
							<label>Ödeme Notu</label>
						</div>
						<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
							<div className={"form-group" + this.validateClass("paymentNote")}>
								<input className="form-control"
									   type="text"
									   data-vlength="0,255"
									   id="paymentNote"
									   name="paymentNote"
									   onBlur={(e) => this.validateField(e)}
									   onChange={this.onChange}
									   value={this.checkValue("paymentNote")}/>
								{this.validateMessage("paymentNote") !== "" &&
								<UncontrolledTooltip placement="right" target={"paymentNote"} delay={0}>
									{this.validateMessage("paymentNote")}
								</UncontrolledTooltip>}
							</div>
						</div>
					</div>
				</div>
			</DefaultModal>
		);
	}
}

export default TouristInfoModal;

